import { createContext, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'

export const TemplateContext = createContext()

export const useTemplateContext = () => {
  return useContext(TemplateContext)
}

const myConfig = {
  theme: {
    palette: {
      primary: {
        main: '#ffffff'
      },
      secondary: {
        main: '#ffffff'
      },
      backgroundColor: '#f5f5f5',
      textColor: '#000000',
    },
    typography: {
      fontFamily: 'Arial, sans-serif', // Primary font
      secondaryFont: {
        fontFamily: 'Georgia, serif',  // Secondary font
      },
      h1: {
        fontFamily: 'Georgia, serif',  // You can also assign it to specific variants
      },
      body1: {
        fontFamily: 'Georgia, serif',  // You can also assign it to specific variants
      }
    },
  },
  logo: {
    src: '',
    fontFamily: 'Arial, sans-serif',
    text: 'Cleaning Services',
  },
  sections: {
    header: {
      title: 'Music'
    },
    hero: {
      title: 'Incredible cleaning services',
      subtitle: 'Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service',
      ctaText: '555-555-5555',
      backgroundImage: 'https://rest.edit.site/image-resize/api/process?url=https://static.edit.site/static/657/photo-047.jpeg&height=523.241',
    },
    navigation: {
      links: [
        'About',
        'Why Choose Us',
        'Services',
        'Pricing',
      ],
      ctaText: 'Book Now',
    },
  }
}

const TemplateProvider = ({ children }) => {
  const [template, setTemplate] = useState(myConfig)

  /**
   * Sets a value in an object using a dot-separated key string.
   * If the key doesn't exist, it creates an empty object for each missing key.
   *
   * @param {string} keyString - The dot-separated key string.
   * @param {*} value - The value to set.
   * @returns {void}
   */
  function safeSetTemplate(keyString, value) {
    setTemplate(prevState => {
      const keys = keyString.split('.');
      let current = { ...prevState }; // Create a shallow copy of the state
  
      // Traverse and copy each level of the state
      let temp = current;
      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
  
        // Ensure each level is copied before updating
        temp[key] = { ...temp[key] };
        temp = temp[key];
      }
  
      // Set the final key to the new value
      if(!isNil(value)) {
        temp[keys[keys.length - 1]] = JSON.parse(JSON.stringify(value));
      }
      return current; // Return the updated state object
    });
  }
  return (
    <TemplateContext.Provider value={{
      template,
      setTemplate,
      safeSetTemplate,
    }}>
      {children}
    </TemplateContext.Provider>
  )
}

TemplateProvider.propTypes = {
  children: PropTypes.node
}

export default TemplateProvider